import React, { Component, PropTypes } from 'react'

import Select from './select'

class SelectContainer extends Component {

  constructor(props) {
    super(props)

    this.state = {
      selected: 'placeholder',
      error: props.error,
    }
    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount() {
    const { name, options, placeholder, onChange } = this.props
    if (!placeholder && onChange) {
      onChange(name, options[0].value)
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ error: nextProps.error })
  }

  handleChange(e) {
    const { name, error, options, placeholder, onChange } = this.props
    const { selectedIndex } = e.target
    const index = placeholder ? selectedIndex - 1 : selectedIndex
    const selected = options[index].value

    this.setState({ selected, error: selected ? false : error })

    if (onChange) {
      onChange(name, selected)
    }
  }

  render() {
    return (
      <Select
        {...this.props}
        {...this.state}
        onChange={this.handleChange}
      />
    )
  }
}

SelectContainer.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })).isRequired,
  placeholder: PropTypes.string,
}

export default SelectContainer



/** WEBPACK FOOTER **
 ** ./src/components/select/select-container.js
 **/